<template>
  <header class="header-area header-style-one intelligent-header not-fixed">
    <div class="header-middle-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3  col-sm-2 col-xs-6">
            <div class="logo">
              <a :href="'..'+localeServicios+'/index.php'"><img src="@/assets/img/logo-tatarana.svg"></a>
            </div>
          </div>
        
          <div class="col-md-9 col-sm-10 hidden-xs hidden-sm">
            <div class="menu-area">
              <nav>
                <ul class="main-menu clearfix">
                  <li><a :href="'..'+localeServicios+'/index.php'">{{ $t("Inicio") }}</a></li>
                  <li><a :href="'..'+localeServicios+'/quienes-somos.php'">{{ $t("¿Quienes somos?") }}</a></li>
                  <li><a href="#" v-on:click.prevent.stop>{{ $t("Servicios") }}<span><i class="ti-angle-down"></i></span></a>
                    <ul>
                      <li><a :href="'..'+localeServicios+'/servicios-catalogacion.php'">{{ $t("Catalogación") }}</a></li>
                      <li><a :href="'..'+localeServicios+'/servicios-procesos-tecnicos.php'">{{ $t("Procesos técnicos") }}</a></li>
                      <li><a :href="'..'+localeServicios+'/servicios-indexacion.php'">{{ $t("Indexación") }}</a></li>
                      <li><a :href="'..'+localeServicios+'/servicios-informacion-seleccion.php'">{{ $t("Información y selección") }}</a></li>
                    </ul>
                  </li>
                  <li><router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'indice' } }">{{ $t("Catálogo productos") }}</router-link></li>            
                  <li><a :href="'..'+localeServicios+'/contacto.php'">{{ $t("Contacto") }}</a></li>
                </ul>
              </nav>
            </div>
          </div>

          <div class="clearfix"></div>
          
          <div class="mobile-menu-area clearfix hidden-md hidden-lg">
            <nav class="mobile-menu">
              <ul>
                <li><a :href="'..'+localeServicios+'/index.php'">{{ $t("Inicio") }}</a></li>
                <li><a :href="'..'+localeServicios+'/quienes-somos.php'">{{ $t("¿Quienes somos?") }}</a></li>
                <li><a href="#">{{ $t("Servicios") }}</a>
                  <ul>
                    <li><a :href="'..'+localeServicios+'/servicios-catalogacion.php'">{{ $t("Catalogación") }}</a></li>
                    <li><a :href="'..'+localeServicios+'/servicios-procesos-tecnicos.php'">{{ $t("Procesos técnicos") }}</a></li>
                    <li><a :href="'..'+localeServicios+'/servicios-indexacion.php'">{{ $t("Indexación") }}</a></li>
                    <li><a :href="'..'+localeServicios+'/servicios-informacion-seleccion.php'">{{ $t("Información y selección") }}</a></li>
                  </ul>                                                    
                </li>
                <li><router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'indice' } }">{{ $t("Catálogo productos") }}</router-link></li>            
                <li><a :href="'..'+localeServicios+'/contacto.php'">{{ $t("Contacto") }}</a></li>
              </ul>
            </nav>
          </div>         

        </div>
      </div>
    </div>
  </header>
</template>

<i18n>
{
  "es": {
    "Inicio": "Inicio",
    "¿Quienes somos?": "¿Quienes somos?",
    "Servicios": "Servicios",
    "Catalogación": "Catalogación",
    "Procesos técnicos": "Procesos técnicos",
    "Indexación": "Indexación",
    "Información y selección": "Información y selección",
    "Catálogo productos": "Catálogo productos",
    "Contacto": "Contacto"
  },
  "en": {
    "Inicio": "Home",
    "¿Quienes somos?": "About",
    "Servicios": "Services",
    "Catalogación": "Cataloging",
    "Procesos técnicos": "Technical processes",
    "Indexación": "Indexing",
    "Información y selección": "Information and selection",
    "Catálogo productos": "Product catalog",
    "Contacto": "Contact"
  }
  ,
  "ca": {
    "Inicio": "Índex",
    "¿Quienes somos?": "¿Qui som?",
    "Servicios": "Serveis",
    "Catalogación": "Catalogació",
    "Procesos técnicos": "Processos tècnics",
    "Indexación": "Indexació",
    "Información y selección": "Informació i selecció",
    "Catálogo productos": "Catàleg de productes",
    "Contacto": "Contacte"
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => {
      return{}
    },
    computed: {
      ...mapGetters(['getLocale']),
      localeServicios: function(){
        return ( (this.getLocale == 'es') ? '' : '/'+this.getLocale );
      }
    },
  }
</script>
